import axiosClient, { ApiResponse, axiosCustomError } from "./axiosClient"
import { ILanguage } from "./LanguageService"

export interface IProviderPhotoTranslation {
    providerPhotoId: number | null
    languageId: number
    title: string
    description: string
    language: ILanguage
}

export interface IProviderPhoto {
    id: number | null
    title: string
    photo: string
    orderNumber: number | null
    published: boolean
    providerId: number
    translations: Array<IProviderPhotoTranslation>
}

export default class ProviderPhotoService {
    static async listAll(providerId: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/ProviderPhotos/${providerId}/All`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async filter(providerId: number, pageIndex: number, pageSize: number, keyword: string) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/ProviderPhotos/${providerId}?keyword=${keyword}&pageSize=${pageSize}&pageIndex=${pageIndex}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async get(providerId: number, id: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/ProviderPhotos/${providerId}/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async delete(providerId: number, id: number) {
        try {
            const { data } = await axiosClient.delete<ApiResponse>(`/api/ProviderPhotos/${providerId}/${id}`, {

            })

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async update(providerId: number, id: number, formData: FormData) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/ProviderPhotos/${providerId}/${id}`, formData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async create(providerId: number, formData: FormData) {
        try {
            const { data } = await axiosClient.post<ApiResponse>(`/api/ProviderPhotos/${providerId}/Create`, formData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async changePublished(providerId: number, id: number) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/ProviderPhotos/${providerId}/ChangePublished/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }
}